// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2ea81205","833":"6fd67e4b"}[chunkId] + ".chunk.js";
};